import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { HeaderWithDescription } from '../../../../modules/common/headerWithDescription/HeaderWithDescription';
import { ColumnLayout } from '../../../../modules/common/layouts/columnLayout/ColumnLayout';
import { SpaceBetweenLayout } from '../../../../modules/common/layouts/spaceBetweenLayout/SpaceBetweenLayout';
import { CreateProjectContainer } from '../../../../modules/projects/project/createProjectModal/CreateProject.container';
import { ImportContainer } from './Import.container';

export const ProjectsHeader = (): ReactElement => {
  const { t } = useTranslator();

  return (
    <>
      <SpaceBetweenLayout>
        <HeaderWithDescription
          header={t('projects_header')}
          description={t('create_project_description')}
        />
        <ColumnLayout size='sm'>
          <CreateProjectContainer />
          <ImportContainer />
        </ColumnLayout>
      </SpaceBetweenLayout>
    </>
  );
};
